import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSidePanel from "../../../../../components/blank-side-pannel/custom-side-pannel";
import { CustomEmptyPage } from "../../../../../components/empty_page/custom-empty-page";
import { ContentWithCardLoading } from "../../../../../components/loading";
import { campaignTableActions, campaignTableFieldDataType, campaignTableMapping, campaingTableFields } from "../../../../campaign-live-status/constants";
import ContentWrapper from "../../../../Wrapper";
import AccountDetailsSubheader from "../../../components/account-details-subheader";
import * as CampaignListActions from "../../../store/actions/account_campaign_actions";
import { CampaignListTable } from "../components/table";
import DetailedAnalyticsReport from "../containers/detailed-analytics-report/index";
import ViewEmailDetailedReport from "../containers/view-detailed-report";
import ErrorOutlineGIF from "../../../../../images/gif/1140-error-outline.gif"
import EnvelopeOutlineGIF from "../../../../../images/gif/177-envelope-mail-send-outline.gif"
import SimpleDropdown from "../../../../../components/dropdowns/simple-dropdown";

export default function AdminCampaignList(props) {
    const tabName = "Campaigns";
    const [pageNo, setPageNo] = useState(1);
    const [limit, setLimit] = useState(10);
    const [accountId, setAccountId] = useState("");
    const [showDetailedAnalytics, setShowDetailedAnalytics] = useState(false);
    const [showDetailedReport, setShowDetailedReport] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [logData, setLogData] = useState("");
    const [showErrorScreen, setShowErrorScreen] = useState(false);
    const [errorType, setErrorType] = useState("");
    const [type, setType] = useState({ value: "application", label: "Campaign" });

    const dispatch = useDispatch();
    const params = useParams();

    const campaignListStore = useSelector((store) => store.accounts.campaign.list);

    useEffect(() => {
        if (accountId) {
            const payload = {
                accountId: accountId,
                query: {
                    limit: limit,
                    pageNo: pageNo,
                    type: type.value
                }
            };
            dispatch(CampaignListActions.getCampaignListRequest(payload));
        }

    }, [dispatch, limit, pageNo, accountId, type]);

    useEffect(() => {
        setAccountId(params.accountId);
    }, [params]);



    const handleDetailedReportClick = (id) => {
        setSelectedId(id);
        setShowDetailedReport(true);
    };
    const handleDetailedAnalytics = (id) => {
        setShowDetailedAnalytics(true);
        setSelectedId(id);
    };
    const handleDetailedAnalyticsErrorScreenClick = (errorType, ErrorLog) => {
        setShowErrorScreen(true);
        setErrorType(errorType);
        setLogData(ErrorLog);
    }
    const handleDetailedAnayticsClose = () => {
        setShowDetailedAnalytics(false);
        setSelectedId("");
    };
    const handleDetailedReportClose = () => {
        setShowDetailedReport(false);
        setSelectedId("");
        setShowErrorScreen(false);
        setErrorType("");
        setLogData("");
    };
    const handleMenuSectionClick = (action, content) => {
        switch (action) {
            case "anaytics":
                return handleDetailedAnalytics(content._id);
            case "report":
                return handleDetailedReportClick(content._id);
            default:
                break;
        }
    };

    const tableRowClick = (content) => {
        if (content.status === "cancelled") {
            return handleDetailedAnalyticsErrorScreenClick("cancelled", content.error)
        } else if (content.status === "failed") {
            return handleDetailedAnalyticsErrorScreenClick("failed", content.error)
        } else if (content.status !== "completed" && content.timezone && content.scheduledDate && content.isScheduled) {
            if (moment(content.scheduledDate).tz(content.timezone).valueOf() > moment().add("minutes").valueOf()) {
                return handleDetailedAnalytics(content._id);
                // return handleDetailedAnalyticsErrorScreenClick("scheduled", content.error);
            } else {
                return handleDetailedAnalytics(content._id);
            }
        } else {
            return handleDetailedAnalytics(content._id);
        }
    }


    return <ContentWrapper
        subHeader={
            <AccountDetailsSubheader active={tabName}>
                <div className="d-flex align-items-center gap-4">
                    <SimpleDropdown
                        value={type}
                        label={"Campaign Type"}
                        options={[{ value: "api", label: "API" }, { value: "application", label: "Campaign" }]}
                        handleSelect={setType}
                    />
                </div>
            </AccountDetailsSubheader>
        }
    >
        {campaignListStore.loading ? (
            <ContentWithCardLoading />
        ) : campaignListStore.data.length === 0 ? (
            <CustomEmptyPage page="campaign" />
        ) : (
            <CampaignListTable
                tablehead={campaingTableFields}
                tablecontent={campaignListStore.data.map((each) => {
                    each.status = each.status === "proccessing" || each.status === "processing" ? "sending" : each.status;
                    return each;
                })}
                mappingTable={campaignTableMapping}
                actions={campaignTableActions}
                dataType={campaignTableFieldDataType}
                pageNo={pageNo}
                limit={limit}
                count={campaignListStore.count}
                setPageNo={setPageNo}
                setLimit={setLimit}
                handleMenuSectionClick={handleMenuSectionClick}
                tableRowClick={tableRowClick}
            />
        )}

        <CustomSidePanel show={showDetailedAnalytics} moduleName={`Detailed Analytics`} handleClose={handleDetailedAnayticsClose} customStyles={{ width: "50vw", right: "51vw" }}>
            <DetailedAnalyticsReport accountId={accountId} campaignId={selectedId} />
        </CustomSidePanel>
        <CustomSidePanel show={showDetailedReport} moduleName={`Detailed Report`} handleClose={handleDetailedReportClose} customStyles={{ width: "80vw", right: "81vw" }}>
            <ViewEmailDetailedReport accountId={accountId} campaignId={selectedId} />
        </CustomSidePanel>

        <CustomSidePanel show={showErrorScreen} moduleName={`Detailed Analytics`} handleClose={handleDetailedReportClose} customStyles={{ width: "50vw", right: "51vw" }}>
            <div className="w-100 h-100 d-flex flex-center">
                <div className="d-flex flex-column gap-8 flex-center mx-20 mt-0">
                    <div>
                        <img width={"200px"} alt="gif" src={errorType === "cancelled" || errorType === "failed" ? ErrorOutlineGIF : EnvelopeOutlineGIF} />
                    </div>
                    {logData && <div className="fw-500 text-active-gray-600 fs-5 text-center text-danger">{logData}</div>}
                    <div className="fw-500 text-active-gray-600 fs-5 text-center">{
                        errorType === "cancelled" || errorType === "failed" ? "Ohh, it seems your campaign has not been successful. Please review the error message for further details, or contact the support team for additional information."
                            : "Sending your campaign... Time for a caffeine boost! 🙂"
                    }
                    </div>
                </div>
            </div>
        </CustomSidePanel>
    </ContentWrapper>
}